import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Spinner } from "react-bootstrap";
import { format } from 'date-fns';
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Programmata', 'Inviata'];

export const ComunicazioneInvitiLista = () => {
	const navigate = useNavigate();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const data_column = [

		{
			Header: 'Data',
			Footer: 'Data',
			accessor: 'comunicazione_date',
			disableGlobalFilter: true,
		},
		{
			Header: 'Titolo',
			Footer: 'Titolo',
			accessor: 'comunicazione_title',
		},

		{
			Header: 'Nr destinatari',
			Footer: 'Nr destinatari',
			accessor: 'comunicazione_number',
			disableGlobalFilter: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'comunicazioni_status',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
			disableFilters: true,
		},
	];

	const editDoc = (row) => {
		navigate('/struttura/comunicazioni/inviti/'+row.id);
    };

	const [data_json, setDataJson] = useState(null);
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() => data_json && data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.comunicazioni_status?.label)),
		[data_json, statoFilter],
	);

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [documentsData] = await Promise.all([
                        apiClient.getCommunications(token)
                    ]);
					setLoadingShowed(false);

					if(documentsData) {
						let data_requests = [];
						documentsData.forEach(element => {
							if(element.type=='SIGNUP_INVITATION') {

								let status = {
									"label": "Programmata",
									"class": "text-blue",
								};

								if(element.scheduledAt<Date.now()) {
									status = {
										"label": "Inviata",
										"class": "text-success",
									};
								}

								let member_row = {
									"id": element.id,
									"comunicazione_date": format(element.scheduledAt, 'dd/MM/yyyy HH:mm:ss'),
									"comunicazione_title": element.subject,
									"comunicazione_number": element.recipientEmails.length ? element.recipientEmails.length : element.recipients.length,
									"comunicazioni_status": status
								};
								data_requests.push(member_row);
							}
						});
						setDataJson(data_requests);
					} else {
						setDataJson([]);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<TabellaLista
				pageList={true}
				openColumn={'comunicazione_title'}
				openRow={(row) => editDoc(row)}
				cardTitle={'Inviti a iscriversi'}
				hasSearch={true}
				searchPlaceholder={'Cerca per titolo'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				hasAddMore={true}
				labelAddMore={'Nuovo invito'}
				linkAddMore={'/struttura/comunicazioni/inviti/add'}
				data_column={data_column}
				data_json={filteredData}
			/>
		</>
	)

}
export default ComunicazioneInvitiLista;